module.exports = __webpack_public_path__ + "static/img/create2.b129243.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/create2.png
// module id = 906
// module chunks = 1